"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var Flex_1 = __importDefault(require("../../../Flex"));
var Text_1 = __importDefault(require("../../../Text"));
var sizeSwitch = function (size) {
    switch (size) {
        case "sm":
            return 24;
        case "md":
            return 32;
        case "lg":
            return 40;
        default:
            return null;
    }
};
var fontSwitch = function (size) {
    switch (size) {
        case "sm":
            return 10;
        case "md":
            return 12;
        case "lg":
            return 16;
        default:
            return null;
    }
};
var BaseAvatar = styled_components_1.default(Flex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: ", "px;\n  min-width: ", "px;\n  max-height: ", "px;\n  max-width: ", "px;\n  object-fit: cover;\n  border-radius: 50%;\n\n  &,\n  ", " {\n    font-size: ", "px;\n  }\n"], ["\n  min-height: ", "px;\n  min-width: ", "px;\n  max-height: ", "px;\n  max-width: ", "px;\n  object-fit: cover;\n  border-radius: 50%;\n\n  &,\n  ", " {\n    font-size: ", "px;\n  }\n"])), function (props) { return sizeSwitch(props.size); }, function (props) { return sizeSwitch(props.size); }, function (props) { return sizeSwitch(props.size); }, function (props) { return sizeSwitch(props.size); }, Text_1.default, function (props) { return fontSwitch(props.size); });
BaseAvatar.defaultProps = {
    alignItems: "center",
    size: "md"
};
exports.default = BaseAvatar;
var templateObject_1;
//# sourceMappingURL=index.js.map